export default __webpack_public_path__ + "static/media/platinum.91259a2f.jpg";